module.exports = __webpack_public_path__ + "static/c_5-b2d080e8f01f2f124d0f517b1f09e301.jpg";